import { ofType } from "redux-observable";
import { EMPTY } from "rxjs";
import { map, retry, switchMap } from "rxjs/operators";
import { selectCoop } from "../../../selectors/selectCoopInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopEditCoopSuccess, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopUpdateMessage = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.UpdateCoopMessage), switchMap(function (action) {
        var state = state$.value;
        var coop = selectCoop(state);
        if (coop) {
            return deps
                .netSend({
                id: CommandCode.UpdateCoop,
                props: {
                    coopId: coop.id,
                    description: coop.description,
                    internalNotice: action.message,
                    joinPolicy: coop.joinPolicy,
                    language: coop.language,
                    minLevel: coop.minLevel,
                    playerId: state.playerInfo.playerId,
                },
            })
                .pipe(map(function (res) {
                return actionCoopEditCoopSuccess(res.coop, res.project);
            }), retry());
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopUpdateMessage.ts
// module id = 1825
// module chunks = 3